import * as yup from 'yup'
import { TFunction } from 'react-i18next'

export function buildValidationSchema(t: TFunction): yup.AnyObjectSchema {
  return yup.object().shape({
    name: yup
      .string()
      .label(t('topic.topic.modal.name'))
      .max(40, ({ label }) =>
        t('validations.maxLength', { label, maxLength: 40 })
      )
      .required(({ label }) => t('validations.required', { label })),
  })
}
